import { ref, watch } from 'vue'

export const useInputForm = (emit, props, fields = ['image', 'video', 'group_image'], LIMIT = 15) => {
  const configForm = ref({ ...props.form })

  watch(
    () => props.form,
    (val) => {
      configForm.value = val
    }
  )

  const onFormChange = () => {
    const form = {}
    for (const key in configForm.value) {
      if (configForm.value[key]) {
        form[key] = parseInt(configForm.value[key])
      } else {
        form[key] = ''
      }
    }
    emit('update:form', form)
  }

  /**
   * @description: 限制最大可配置数量，图片+视频+组图不能大于15
   * 对输入进行类型校验和归一化处理
   * @param {string} prop 当前修改的属性名：'image' | 'video' | 'group_image'
   * @param {number} [limitValue] 单个字段的最大值限制（可选）
   */
  const onInputBlur = (prop, limitValue) => {
    // 辅助函数：安全地转换为非负整数
    const getSafeNumber = (val) => {
      const num = Number(val)
      // 如果不是数字，或者小于0，则默认为0
      if (isNaN(num) || num < 0) {
        return 0
      }
      return num
    }

    // 1. 获取当前表单值，并进行类型转换
    const currentForm = { ...configForm.value }
    const safeValues = {}
    let otherSum = 0

    fields.forEach((key) => {
      const val = getSafeNumber(currentForm[key])
      safeValues[key] = val

      // 计算除了当前 prop 以外的其他字段总和
      if (key !== prop) {
        otherSum += val
      }
    })

    // 2. 获取当前字段的输入值（经过校验）
    let currentPropValue = safeValues[prop]

    // 3. 计算允许的最大值
    // 3.1 基于总和限制 (LIMIT) 计算当前字段允许的最大值
    const maxAllowedByTotal = Math.max(0, LIMIT - otherSum)

    // 3.2 基于单个字段限制 (limitValue) 计算最大值
    let maxAllowedByLimit = Infinity
    // 检查 limitValue 是否有效（非null/undefined且非空）
    if (limitValue !== null && limitValue !== undefined && limitValue !== '') {
      const parsed = Number(limitValue)
      if (!isNaN(parsed) && parsed >= 0) {
        maxAllowedByLimit = parsed
      }
    }

    // 3.3 取两者的较小值作为最终限制
    // 如果总和限制更严格，则遵循总和限制；如果单字段限制更严格，则遵循单字段限制
    const effectiveLimit = Math.min(maxAllowedByTotal, maxAllowedByLimit)

    // 4. 应用限制
    if (currentPropValue > effectiveLimit) {
      currentPropValue = effectiveLimit
    }

    // 5. 更新表单
    // 即使值没有超限，如果原输入是字符串或非法值，这里也会将其修正为合法的数字
    const newForm = {
      ...currentForm,
      [prop]: currentPropValue,
      // 创意组不参与计算
      group: prop === 'group' && currentForm.group > limitValue ? limitValue : currentForm.group
    }

    emit('update:form', newForm)
  }

  return {
    configForm,
    onFormChange,
    onInputBlur
  }
}
